import { render, staticRenderFns } from "./DowngradeOrgAdminConfirmation.vue?vue&type=template&id=4e4af3d0&scoped=true&"
import script from "./DowngradeOrgAdminConfirmation.vue?vue&type=script&lang=js&"
export * from "./DowngradeOrgAdminConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DowngradeOrgAdminConfirmation.vue?vue&type=style&index=0&id=4e4af3d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4af3d0",
  null
  
)

export default component.exports